<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card>

      </md-card>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>